// Translations
import accessKeyManager from 'components/model/access-key-manager/translations/en'
import copyButton from 'components/interface/copy-button/translations/en'
import feedback from 'components/utility/feedback/translations/en'
import loadingError from 'components/utility/loading-error/translations/en'
import pagination from 'components/interface/pagination/translations/en'
import phoneNumberVerifier from 'components/model/phone-number-verifier/translations/en'
import providerButton from 'components/external/provider-button/translations/en'

// Translation: English > Components
const components = Object.freeze({
	external: { providerButton },
	interface: { copyButton, pagination },
	model: { accessKeyManager, phoneNumberVerifier },
	utility: { feedback, loadingError }
})

// Export
export default components
